import _implicitStylesheets from "./tilesGrid.css";
import _implicitScopedStylesheets from "./tilesGrid.scoped.css?scoped=true";
import _wdsContentTitle from "wds/contentTitle";
import _wdsContentText from "wds/contentText";
import _wdsButton from "wds/button";
import _wdsListingTile from "wds/listingTile";
import _wdsContentTile from "wds/contentTile";
import _wdsGridItem from "wds/gridItem";
import _wdsGrid from "wds/grid";
import _adsIcon from "ads/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="text${0}"${2}><p${3}><strong${3}>${"t3"}</strong></p><p${3}>${"t5"}</p></div>`;
const stc0 = {
  classMap: {
    "header": true
  },
  key: 1
};
const stc1 = {
  classMap: {
    "sub-title-container": true
  },
  key: 2
};
const stc2 = {
  attrs: {
    "name": "tooltip_slot"
  },
  key: 5
};
const stc3 = [];
const stc4 = {
  classMap: {
    "sub-title-middle": true
  },
  key: 6
};
const stc5 = {
  key: 7
};
const stc6 = {
  attrs: {
    "name": "tooltip_slot"
  },
  key: 10
};
const stc7 = {
  attrs: {
    "name": "actions"
  },
  key: 13
};
const stc8 = {
  "grid": true
};
const stc9 = {
  classMap: {
    "error": true
  },
  key: 21
};
const stc10 = {
  classMap: {
    "details": true
  },
  key: 22
};
const stc11 = {
  props: {
    "size": "large",
    "fill": "var(--sds-g-color-palette-orange-70)",
    "symbol": "warning"
  },
  key: 23
};
const stc12 = {
  classMap: {
    "showmore-bottom": true
  },
  key: 26
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, ncls: api_normalize_class_name, s: api_slot, c: api_custom_element, h: api_element, d: api_dynamic_text, t: api_text, k: api_key, i: api_iterator, f: api_flatten, sp: api_static_part, st: api_static_fragment} = $api;
  const {_m0} = $ctx;
  return [api_element("div", {
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [$cmp.showHeader ? api_element("div", stc0, [$cmp.showSubTitle ? api_element("div", stc1, [api_element("div", {
    className: api_normalize_class_name($cmp.titleClass),
    key: 3
  }, [api_custom_element("wds-content-title", _wdsContentTitle, {
    props: {
      "level": "7",
      "truncate": "false",
      "isLoading": $cmp.isLoading,
      "title": $cmp.title
    },
    key: 4
  }, [api_slot("tooltip_slot", stc2, stc3, $slotset)])]), api_element("div", stc4, [api_custom_element("wds-content-text", _wdsContentText, stc5, [api_text(api_dynamic_text($cmp.subTitle))])])]) : null, !$cmp.showSubTitle ? api_element("div", {
    className: api_normalize_class_name($cmp.titleClass),
    key: 8
  }, [api_custom_element("wds-content-title", _wdsContentTitle, {
    props: {
      "level": $cmp.level,
      "truncate": "false",
      "isLoading": $cmp.isLoading,
      "title": $cmp.title,
      "customStyles": $cmp.customTitle
    },
    key: 9
  }, [api_slot("tooltip_slot", stc6, stc3, $slotset)])]) : null, !$cmp.isMobile ? api_element("div", {
    className: api_normalize_class_name($cmp.showMoreClass),
    key: 11
  }, [$cmp.displayShowMore ? api_custom_element("wds-button", _wdsButton, {
    props: {
      "href": $cmp.showMore.url,
      "label": $cmp.showMore.label,
      "variant": "text",
      "icon": $cmp.showMoreSymbol,
      "iconPlacement": "end"
    },
    key: 12
  }) : null]) : null, api_slot("actions", stc7, stc3, $slotset)]) : null, !$cmp.errorOrNoRecords ? api_custom_element("wds-grid", _wdsGrid, {
    classMap: stc8,
    props: {
      "gridAlignItems": $cmp.gridAlignItems,
      "gridAxis": $cmp.gridAxis,
      "gridFlow": $cmp.gridFlow,
      "gridGap": $cmp.gridGap,
      "gridRowGap": $cmp.gridRowGap
    },
    key: 14
  }, api_flatten([$cmp.hasRecords ? api_iterator($cmp.records, function (item, index) {
    return api_custom_element("wds-grid-item", _wdsGridItem, {
      className: api_normalize_class_name($cmp.showGridClass),
      props: {
        "gridItemSize": $cmp.gridItemSize,
        "gridItemAlign": "stretch"
      },
      key: api_key(15, item.key)
    }, [$cmp.isListing ? api_custom_element("wds-listing-tile", _wdsListingTile, {
      props: {
        "role": "group",
        "variant": $cmp.variant,
        "isSponsored": $cmp.isSponsored,
        "positionIndex": index,
        "labelChatBadge": $cmp.labelChatBadge,
        "props": item
      },
      key: 16
    }) : null, $cmp.isContent ? api_custom_element("wds-content-tile", _wdsContentTile, {
      props: {
        "role": "group",
        "variant": $cmp.variant,
        "props": item,
        "positionIndex": index
      },
      key: 17
    }) : null]);
  }) : stc3, $cmp.isLoading ? api_iterator($cmp.empty, function (item) {
    return api_custom_element("wds-grid-item", _wdsGridItem, {
      props: {
        "gridItemSize": $cmp.gridItemSize
      },
      key: api_key(18, item)
    }, [$cmp.isListing ? api_custom_element("wds-listing-tile", _wdsListingTile, {
      props: {
        "isSponsored": $cmp.isSponsored,
        "isLoading": "true",
        "variant": $cmp.variant
      },
      key: 19
    }) : null, $cmp.isContent ? api_custom_element("wds-content-tile", _wdsContentTile, {
      props: {
        "isLoading": "true",
        "variant": $cmp.variant
      },
      key: 20
    }) : null]);
  }) : stc3])) : null, $cmp.errorOrNoRecords ? api_element("div", stc9, [api_element("div", stc10, [api_custom_element("ads-icon", _adsIcon, stc11), api_static_fragment($fragment1, 25, [api_static_part(3, null, api_dynamic_text($cmp.staticLabels.title)), api_static_part(5, null, api_dynamic_text($cmp.staticLabels.description))])])]) : null]), $cmp.isMobile ? api_element("div", stc12, [$cmp.showMore ? api_custom_element("wds-button", _wdsButton, {
    props: {
      "href": $cmp.showMore.url,
      "label": $cmp.showMore.label,
      "variant": "text",
      "icon": $cmp.showMoreSymbol,
      "iconPlacement": "end"
    },
    key: 27
  }) : null]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["actions", "tooltip_slot"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-17066h38a3k";
tmpl.legacyStylesheetToken = "undefined-_tilesGrid";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
